import React from "react";
import { Button, Form, InputNumber, Space } from "antd";
import type { FormInstance } from "antd/es/form";
import {
  optionalBookingFeeInputProps,
} from "../../utils/agentBookingFees";

interface AgentOptionalFeeFieldProps {
  form: FormInstance;
  name: "pick_up_fee" | "post_export_license";
  label: string;
  onClear: () => void;
}

export const AgentOptionalFeeField: React.FC<AgentOptionalFeeFieldProps> = ({
  form,
  name,
  label,
  onClear,
}) => {
  const currentValue = Form.useWatch(name, form);

  const handleClear = () => {
    form.setFieldValue(name, null);
    onClear();
  };

  return (
    <Form.Item
      label={
        <Space
          style={{ width: "100%", justifyContent: "space-between" }}
          align="center"
        >
          <span>{label}</span>
          {currentValue != null ? (
            <Button
              type="link"
              size="small"
              style={{ padding: 0, height: "auto", fontSize: 12 }}
              onClick={handleClear}
            >
              Clear
            </Button>
          ) : null}
        </Space>
      }
      name={name}
      style={{ marginBottom: 12 }}
      getValueProps={optionalBookingFeeInputProps}
    >
      <InputNumber
        min={0}
        precision={2}
        style={{ width: "100%" }}
        placeholder="Not set"
        controls
      />
    </Form.Item>
  );
};
